export const fleetSizesRoutes = {
    api: {
        base: (): string => '/fleet_sizes',
    },
};

